module.exports = __webpack_public_path__ + "img/australia-liver-cancer-male.ce3c05cc.png";